import { Card } from './Card.style';
export default Card;
